import '../styles/Features.css'

function Features() {
  const features = [
    {
      icon: '🎯',
      title: 'Action-Based Profiles',
      description: 'Build your identity around what you actually do—not just photos and bios. Show who you are through your activities and passions.'
    },
    {
      icon: '🧭',
      title: 'Discover Activities',
      description: 'Find things to do near you. From hiking groups to art classes, explore new experiences while meeting like-minded people.'
    },
    {
      icon: '👥',
      title: 'Join Groups',
      description: 'Connect with communities that share your interests. Build friendships and find potential partners through shared activities.'
    },
    {
      icon: '✨',
      title: 'More Than Swiping',
      description: "Move beyond superficial matches. Connect through shared experiences and common interests, not just left or right swipes."
    },
    {
      icon: '🌟',
      title: 'Holistic Social App',
      description: 'Whether dating, making friends, or finding activity partners—one platform for all your social connections.'
    },
    {
      icon: '💝',
      title: 'Meaningful Connections',
      description: 'Build relationships based on what you love to do. From friendships to romance, connect authentically through shared passions.'
    }
  ]

  return (
    <section className="features" role="main" aria-labelledby="features-heading">
      <div className="features-container">
        <h2 id="features-heading" className="features-title">Why Choose Breakout Dating App?</h2>
        <p className="features-subtitle">
          A holistic social platform connecting people through shared interests and experiences. Perfect for dating, making friends, and building meaningful relationships.
        </p>
        <div className="features-grid" role="list">
          {features.map((feature, index) => (
            <article key={index} className="feature-card" role="listitem">
              <div className="feature-icon" aria-hidden="true">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Features
